export const getChampagneData = () => ({
  name: "Champagne",
  country: "France",
  description: "La Champagne est la région des vins effervescents par excellence, produisant le champagne, le roi des vins et le vin des rois. Cette région du nord-est de la France bénéficie d'un climat continental frais et de sols crayeux qui donnent aux vins leur finesse et leur élégance caractéristiques.",
  type: "region",
  mapAreas: [
    { region: "Champagne", x: 40, y: 25, color: "#4B164C", size: 6 }
  ],
  statistics: {
    totalArea: "34,000 ha",
    production: "300 million bottles",
    villages: "319 villages",
    appellations: "5 sous-régions",
    exportPercentage: "55%"
  },
  characteristics: {
    climate: "Climat continental frais avec des hivers rigoureux et des étés modérés",
    soil: "Sols crayeux et calcaires, excellents pour la rétention d'eau et la minéralité",
    viticulture: "Rendements limités, vendanges manuelles, méthode traditionnelle"
  },
  wineStyles: {
    brut: "Champagne sec et équilibré, parfait pour l'apéritif",
    extra_brut: "Champagne très sec, pour les amateurs de vins secs",
    sec: "Champagne légèrement doux, pour accompagner les desserts",
    rose: "Champagne rosé, élégant et fruité",
    vintage: "Champagne de millésime, complexe et de garde"
  },
  history: "La viticulture en Champagne remonte à l'époque romaine. Au XVIIe siècle, Dom Pérignon a perfectionné la méthode de production des vins effervescents. Le XIXe siècle a vu l'émergence des grandes maisons de champagne. Aujourd'hui, la Champagne est synonyme de luxe et de célébration.",
  foodPairing: "Apéritifs, fruits de mer, volailles, fromages affinés, desserts",
  subregions: {
    "montagne-de-reims": {
      name: "Montagne de Reims",
      description: "Région de coteaux plantés principalement en Pinot Noir, produisant des champagnes puissants et structurés.",
      characteristics: {
        climate: "Climat continental avec influence océanique",
        soil: "Sols crayeux et calcaires",
        viticulture: "Vendanges manuelles, rendements limités"
      },
      grapeVarieties: {
        red: ["Pinot Noir"],
        white: ["Chardonnay", "Pinot Meunier"]
      },
      wineStyles: {
        "champagne-rouge": "Champagnes rouges puissants et tanniques",
        "champagne-blanc": "Champagnes blancs élégants et complexes"
      },
      foodPairing: "Viandes rouges, fromages affinés, cuisine gastronomique"
    },
    "vallee-de-la-marne": {
      name: "Vallée de la Marne",
      description: "Région de vallées plantées principalement en Pinot Meunier, produisant des champagnes fruités et accessibles.",
      characteristics: {
        climate: "Climat continental tempéré",
        soil: "Sols argilo-calcaires et marneux",
        viticulture: "Vignobles en coteaux et en vallées"
      },
      grapeVarieties: {
        red: ["Pinot Meunier", "Pinot Noir"],
        white: ["Chardonnay"]
      },
      wineStyles: {
        "champagne-fruite": "Champagnes fruités et aromatiques",
        "champagne-doux": "Champagnes demi-secs et doux"
      },
      foodPairing: "Apéritifs, desserts, cuisine traditionnelle"
    },
    "cote-des-blancs": {
      name: "Côte des Blancs",
      description: "Région de coteaux plantés exclusivement en Chardonnay, produisant des champagnes blancs de blancs d'une finesse exceptionnelle.",
      characteristics: {
        climate: "Climat continental frais",
        soil: "Sols crayeux purs, excellents pour le Chardonnay",
        viticulture: "Vignobles orientés sud-est"
      },
      grapeVarieties: {
        white: ["Chardonnay"]
      },
      wineStyles: {
        "blanc-de-blancs": "Champagnes blancs de blancs, fins et élégants",
        "champagne-mineral": "Champagnes minéraux et complexes"
      },
      foodPairing: "Fruits de mer, poissons, fromages frais"
    },
    "cote-de-sezanne": {
      name: "Côte de Sézanne",
      description: "Région de coteaux plantés principalement en Chardonnay, produisant des champagnes équilibrés et accessibles.",
      characteristics: {
        climate: "Climat continental modéré",
        soil: "Sols crayeux et argileux",
        viticulture: "Vignobles en coteaux"
      },
      grapeVarieties: {
        white: ["Chardonnay"],
        red: ["Pinot Noir", "Pinot Meunier"]
      },
      wineStyles: {
        "champagne-equilibre": "Champagnes équilibrés et harmonieux",
        "champagne-accessible": "Champagnes accessibles et fruités"
      },
      foodPairing: "Apéritifs, cuisine légère, desserts"
    },
    "aube": {
      name: "Aube",
      description: "Région méridionale de la Champagne, plantée principalement en Pinot Noir, produisant des champagnes puissants et colorés.",
      characteristics: {
        climate: "Climat continental chaud",
        soil: "Sols argilo-calcaires et kimméridgiens",
        viticulture: "Vignobles en coteaux"
      },
      grapeVarieties: {
        red: ["Pinot Noir"],
        white: ["Chardonnay", "Pinot Meunier"]
      },
      wineStyles: {
        "champagne-puissant": "Champagnes puissants et structurés",
        "champagne-colore": "Champagnes rosés et colorés"
      },
      foodPairing: "Viandes rouges, fromages affinés, cuisine traditionnelle"
    }
  }
}); 